export const ASSESSMENT = '/assessment/'
